export default "__VITE_ASSET__57dc630f__"